import {addressForHash} from "../address/addressSelectors";

export const selectShippingGroups = state => state.shippingGroups;

export const selectShippingGroupsWithAddressHash = (state, addressHash) => {
    const shippingGroups = selectShippingGroups(state);
    return Object.assign({}, Object.keys(shippingGroups).filter(key =>
        shippingGroups[key].toAddressHash === addressHash
    ));
};
export const shippingGroupForId = (state, shippingGroupId) => {
    const groupForId = selectShippingGroups(state)[shippingGroupId];
    return {
        ...groupForId,
        ...groupForId && { toAddress: addressForHash(state, groupForId.toAddressHash)}
    }
};
